import type { GbTier } from "@/lib/pricing-utils";

export const PRICING_VERIFIED_DATE = "July 6, 2026";

export const OXYLABS_URL = "https://oxylabs.io";
export const OXYLABS_MOBILE_URL = "https://oxylabs.io/products/mobile-proxies";
export const OXYLABS_RESIDENTIAL_URL = "https://oxylabs.io/products/residential-proxy-pool";
export const OXYLABS_TRUSTPILOT_URL = "https://www.trustpilot.com/review/oxylabs.io";
export const OXYLABS_G2_URL = "https://www.g2.com/products/oxylabs/reviews";

export type ProxyProduct = "mobile" | "residential";

export interface OxylabsPlan {
  name: string;
  gb: number;
  monthlyPrice: number;
  perGb: number;
}

export const OXYLABS_MOBILE_PLANS: OxylabsPlan[] = [
  { name: "Starter", gb: 4, monthlyPrice: 30, perGb: 7.5 },
  { name: "Basic", gb: 15, monthlyPrice: 100, perGb: 6.67 },
  { name: "Advanced", gb: 100, monthlyPrice: 500, perGb: 5 },
  { name: "Corporate", gb: 715, monthlyPrice: 2500, perGb: 3.5 },
];

export const OXYLABS_RESIDENTIAL_PLANS: OxylabsPlan[] = [
  { name: "Starter", gb: 5, monthlyPrice: 30, perGb: 6 },
  { name: "Basic", gb: 20, monthlyPrice: 100, perGb: 5 },
  { name: "Advanced", gb: 125, monthlyPrice: 500, perGb: 4 },
  { name: "Corporate", gb: 1000, monthlyPrice: 2500, perGb: 2.5 },
];

export const PROXIDIZE_MOBILE_FALLBACK_TIERS: GbTier[] = [
  { gb: 25, monthlyPPG: 2, totalPrice: 50 },
  { gb: 50, monthlyPPG: 2, totalPrice: 100 },
  { gb: 100, monthlyPPG: 2, totalPrice: 200 },
  { gb: 200, monthlyPPG: 2, totalPrice: 400 },
  { gb: 500, monthlyPPG: 2, totalPrice: 1000 },
  { gb: 1000, monthlyPPG: 2, totalPrice: 2000 },
  { gb: 2000, monthlyPPG: 2, totalPrice: 4000 },
  { gb: 5000, monthlyPPG: 2, totalPrice: 10000 },
  { gb: 10000, monthlyPPG: 2, totalPrice: 20000 },
];

export const PROXIDIZE_RESIDENTIAL_FALLBACK_TIERS: GbTier[] = [
  { gb: 25, monthlyPPG: 1, totalPrice: 25 },
  { gb: 50, monthlyPPG: 1, totalPrice: 50 },
  { gb: 100, monthlyPPG: 1, totalPrice: 100 },
  { gb: 200, monthlyPPG: 1, totalPrice: 200 },
  { gb: 500, monthlyPPG: 1, totalPrice: 500 },
  { gb: 1000, monthlyPPG: 1, totalPrice: 1000 },
  { gb: 2000, monthlyPPG: 0.95, totalPrice: 1900 },
  { gb: 5000, monthlyPPG: 0.95, totalPrice: 4750 },
  { gb: 10000, monthlyPPG: 0.9, totalPrice: 9000 },
];

export interface OxylabsCost {
  cost: number;
  planLabel: string;
  extrapolated: boolean;
}

export function oxylabsMonthlyCost(product: ProxyProduct, gb: number): OxylabsCost {
  const plans = product === "mobile" ? OXYLABS_MOBILE_PLANS : OXYLABS_RESIDENTIAL_PLANS;
  const plan = plans.find((p) => p.gb >= gb);
  if (plan)
    return {
      cost: plan.monthlyPrice,
      planLabel: `${plan.name} plan (${plan.gb} GB)`,
      extrapolated: false,
    };
  const top = plans[plans.length - 1];
  const cost = Math.round(top.monthlyPrice + (gb - top.gb) * top.perGb);
  return { cost, planLabel: `${top.name} plan + top-up`, extrapolated: true };
}
